import { module as BaseModule } from 'modujs'
import ImagesLoaded from 'imagesloaded'

export default class extends BaseModule {
  constructor(m) {
    super(m)
  }

  init() {
    const image = this.el.querySelector('.--loading')

    const imgLoad = new ImagesLoaded(image)

    imgLoad.on('done', () => {
      image.classList.add('--loaded')
    })
  }
}
